module.exports = __webpack_public_path__ + "img/turnGo.df0b5851.png";